import { Routes } from '@angular/router';

import { RootComponent } from '../root/root.component';
import { ListComponent } from './list/list.component';
import { SummaryComponent } from './summary/summary.component';
import { AddComponent } from './add/add.component';

import { AuthGuard } from '../auth.guard';
import { ConvertComponent } from './convert/convert.component';

export const routing: Routes = [
  {
    path: 'lead',
    data: {
      breadcrumb_en: 'Leads',
      breadcrumb_es: 'Iniciativas'
    },
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      {
        path: '', component: ListComponent,
        data: {
          breadcrumb_en: 'Lead List',
          breadcrumb_es: 'Lista de Clientes Potenciales'
        },
      },
      {
        path: 'list', component: ListComponent,
        data: {
          breadcrumb_en: 'Lead List',
          breadcrumb_es: 'Lista de Clientes Potenciales'
        },
      },
      {
        path: 'add', component: AddComponent,
        data: {
          breadcrumb_en: 'Add New Lead',
          breadcrumb_es: 'Anadir Cliente Pontencial'
        },
      },
      {
        path: 'convert/:quoteId', component: ConvertComponent,
        data: {
          breadcrumb_en: 'Convert Lead',
          breadcrumb_es: 'Convertir Iniciativa'
        },
      },
      {
        path: ':quoteId', component: SummaryComponent,
        data: {
          breadcrumb_en: 'Edit Lead',
          breadcrumb_es: 'Editar Iniciativa'
        },
      },
    ]
  }
];
